export const CORRESPONDANCE_STATUS = {
    DRAFT : "Draft",
    RECIEVED: "Recieved",
    SENT:"Sent"
}